import { render, staticRenderFns } from "./CreateTemplate.vue?vue&type=template&id=61b91490&scoped=true&"
import script from "./CreateTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CreateTemplate.vue?vue&type=style&index=0&id=61b91490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b91490",
  null
  
)

export default component.exports